export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa0d6a0558226206fbc52aa61e594ab295edd874d&name=fetchTypeahead!'